const storagePrefix = 'nova_';
const adminTokenChangedEvent = 'nova_admin_token_changed';

const storage = {
  getToken: (): string => {
    return JSON.parse(window.localStorage.getItem(`${storagePrefix}token`) as string);
  },
  setToken: (token: string) => {
    window.localStorage.setItem(`${storagePrefix}token`, JSON.stringify(token));
  },
  setTenant: (tenant: string) => {
    window.localStorage.setItem(`${storagePrefix}tenant`, JSON.stringify(tenant));
  },
  getTenant: (): string => {
    return JSON.parse(window.localStorage.getItem(`${storagePrefix}tenant`) as string);
  },
  clearTenant: () => {
    window.localStorage.removeItem(`${storagePrefix}tenant`);
  },
  clearToken: () => {
    window.localStorage.removeItem(`${storagePrefix}token`);
  },
  getAdminToken: (): string => {
    return JSON.parse(window.localStorage.getItem(`${storagePrefix}adminToken`) as string);
  },
  setAdminToken: (token: string) => {
    window.localStorage.setItem(`${storagePrefix}adminToken`, JSON.stringify(token));
    window.dispatchEvent(new Event(adminTokenChangedEvent));
  },
  setAdminTenant: (tenant: string) => {
    window.localStorage.setItem(`${storagePrefix}adminTenant`, JSON.stringify(tenant));
  },
  getAdminTenant: (): string => {
    return JSON.parse(window.localStorage.getItem(`${storagePrefix}adminTenant`) as string);
  },
  clearAdminSession: () => {
    window.localStorage.removeItem(`${storagePrefix}adminToken`);
    window.localStorage.removeItem(`${storagePrefix}adminTenant`);
    window.dispatchEvent(new Event(adminTokenChangedEvent));
  },
  clearStorage: () => {
    storage.clearToken();
    storage.clearTenant();
    storage.clearAdminSession();
  },
};

export default storage;
export { adminTokenChangedEvent };
